import Tabs from './components/Tabs';
import TabContent from './components/TabContent';
import TabLink from './components/TabLink';

export { Tabs, TabContent, TabLink };
